"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_MARKETING_IMAGES_FOR_PRODUCT = void 0;
var client_1 = require("@apollo/client");
exports.GET_MARKETING_IMAGES_FOR_PRODUCT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query MarketingImageForProduct($productId: String!) {\n    marketingImagesForProduct(productId: $productId) {\n      id\n      url\n      bucketFileName\n    }\n  }\n"], ["\n  query MarketingImageForProduct($productId: String!) {\n    marketingImagesForProduct(productId: $productId) {\n      id\n      url\n      bucketFileName\n    }\n  }\n"])));
var templateObject_1;
